import { ISlideFactoryGeneric } from "../Slider/ISlideFactory";
import { SlotGameType1_2 } from "../SlotGameType1_2";

// import { ResourceManager } from "../../ResourceManager/ResourceManager";
import { SlideFactory } from "../Slider/SecondScreenHelp";
import { FactoryDoubleSlide } from "../Slider/Slide2/FactoryDoubleSlide";
// import { SetStyles } from "../.././MyHelpers";

//namespace SlotGames2
//{
	export class SpiritOfThunder2 extends SlotGameType1_2
	{
		protected override seconScreenHelpFactory:ISlideFactoryGeneric = new FactoryDoubleSlide();
	}

	class SpiritOfThunderSecondScreenHelpFactory extends SlideFactory
	{
		public override CreateStyle():Partial<CSSStyleDeclaration>
		{
			let style: Partial<CSSStyleDeclaration> = 
			{
				color:"White"
			};
			return style;
		}
	}
	
//}